import React from 'react';
import { View } from 'react-native';

import AlertSVG from '~/assets/svgs/alert.svg';
import CheckSVG from '~/assets/svgs/check.svg';
import colors from '~/assets/themes/colors';

export interface CancelStatusProps {
  type: 'alert' | 'success';
}

const CancelStatus: React.FC<CancelStatusProps> = ({ type }) => {
  if (type === 'success') {
    return (
      <View className="bg-[#F4FDF9] rounded-full p-3 my-6 justify-center items-center mx-auto">
        <View className="bg-feedback-success-main rounded-full p-3 justify-center items-center mx-auto">
          <CheckSVG color={colors.light[100]} height={32} width={32} />
        </View>
      </View>
    );
  }

  return (
    <View className="bg-[#FFF8F8] rounded-full p-3 my-6 justify-center items-center mx-auto">
      <View className="bg-feedback-error-main rounded-full p-3 justify-center items-center mx-auto">
        <AlertSVG color={colors.light[100]} height={32} width={32} />
      </View>
    </View>
  );
};

export default CancelStatus;
